import { MediaLibrary } from '@/components/MediaLibrary'

/** Port of pages/Media.vue */
export function MediaPage() {
  return (
    <div className="media-page">
      <MediaLibrary />
    </div>
  )
}
